import React from 'react';
import styled from 'styled-components';

import CloseIcon from '@material-ui/icons/Close';

const CloseBtn = ({ onClick }) => {
  return (
    <CloseBtnStyled onClick={onClick}>
      <CloseIcon />
    </CloseBtnStyled>
  );
};

export default CloseBtn;

const CloseBtnStyled = styled.button`
  border: none;
  background-color: transparent;
  color: #aaaaaa;
  padding: 0;

  & > svg {
    color: ${props => props.theme.subLine};
  }
`;
